import * as Types from '../../../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetMaterialArticleIdQueryVariables = Types.Exact<{
  materialLegacyId: Types.Scalars['Int']['input'];
}>;


export type GetMaterialArticleIdQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string, articleId?: string | null } | null };

export type GetMaterialLegacyIdQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type GetMaterialLegacyIdQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string, legacyId: number } | null };

export type GetMaterialIdQueryVariables = Types.Exact<{
  materialLegacyId: Types.Scalars['Int']['input'];
}>;


export type GetMaterialIdQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string } | null };

export type GetMaterialSizeQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetMaterialSizeQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string, textureGroupDimensions?: { __typename: 'ConfiguratorTextureGroupDimensions', width?: number | null, height?: number | null } | null } | null };

export type GetMaterialIdByArticleIdQueryVariables = Types.Exact<{
  articleId: Types.Scalars['String']['input'];
  organizationId: Types.Scalars['ID']['input'];
}>;


export type GetMaterialIdByArticleIdQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string, legacyId: number } | null };

export type GetTemplateIdQueryVariables = Types.Exact<{
  templateLegacyId: Types.Scalars['Int']['input'];
}>;


export type GetTemplateIdQuery = { __typename: 'Query', configuratorData?: { __typename: 'ConfiguratorTemplate', id: string } | null };

export type GetTemplateLegacyIdQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type GetTemplateLegacyIdQuery = { __typename: 'Query', configuratorData?: { __typename: 'ConfiguratorTemplate', id: string, legacyId: number } | null };

export type GetDefaultCameraTemplateGraphQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type GetDefaultCameraTemplateGraphQuery = { __typename: 'Query', configuratorData?: { __typename: 'ConfiguratorTemplate', id: string, latestRevision?: { __typename: 'ConfiguratorTemplateRevision', id: string, graph?: any | null } | null } | null };

export type GetMaterialTagsQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type GetMaterialTagsQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string, tagNames: Array<string> } | null };

export type GetTemplateTagsQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type GetTemplateTagsQuery = { __typename: 'Query', configuratorData?: { __typename: 'ConfiguratorTemplate', id: string, tagNames: Array<string> } | null };

export const GetMaterialArticleIdDocument = gql`
    query getMaterialArticleId($materialLegacyId: Int!) {
  configuratorMaterial(materialLegacyId: $materialLegacyId) {
    id
    articleId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialArticleIdGQL extends Apollo.Query<GetMaterialArticleIdQuery, GetMaterialArticleIdQueryVariables> {
    override document = GetMaterialArticleIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaterialLegacyIdDocument = gql`
    query getMaterialLegacyId($materialId: ID!) {
  configuratorMaterial(materialId: $materialId) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialLegacyIdGQL extends Apollo.Query<GetMaterialLegacyIdQuery, GetMaterialLegacyIdQueryVariables> {
    override document = GetMaterialLegacyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaterialIdDocument = gql`
    query getMaterialId($materialLegacyId: Int!) {
  configuratorMaterial(materialLegacyId: $materialLegacyId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialIdGQL extends Apollo.Query<GetMaterialIdQuery, GetMaterialIdQueryVariables> {
    override document = GetMaterialIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaterialSizeDocument = gql`
    query getMaterialSize($id: ID!) {
  configuratorMaterial(materialId: $id) {
    id
    textureGroupDimensions {
      width
      height
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialSizeGQL extends Apollo.Query<GetMaterialSizeQuery, GetMaterialSizeQueryVariables> {
    override document = GetMaterialSizeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaterialIdByArticleIdDocument = gql`
    query getMaterialIdByArticleId($articleId: String!, $organizationId: ID!) {
  configuratorMaterial(articleId: $articleId, organizationId: $organizationId) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialIdByArticleIdGQL extends Apollo.Query<GetMaterialIdByArticleIdQuery, GetMaterialIdByArticleIdQueryVariables> {
    override document = GetMaterialIdByArticleIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplateIdDocument = gql`
    query getTemplateId($templateLegacyId: Int!) {
  configuratorData(templateLegacyId: $templateLegacyId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateIdGQL extends Apollo.Query<GetTemplateIdQuery, GetTemplateIdQueryVariables> {
    override document = GetTemplateIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplateLegacyIdDocument = gql`
    query getTemplateLegacyId($templateId: ID!) {
  configuratorData(templateId: $templateId) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateLegacyIdGQL extends Apollo.Query<GetTemplateLegacyIdQuery, GetTemplateLegacyIdQueryVariables> {
    override document = GetTemplateLegacyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultCameraTemplateGraphDocument = gql`
    query getDefaultCameraTemplateGraph($templateId: ID!) {
  configuratorData(templateId: $templateId) {
    id
    latestRevision {
      id
      graph
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultCameraTemplateGraphGQL extends Apollo.Query<GetDefaultCameraTemplateGraphQuery, GetDefaultCameraTemplateGraphQueryVariables> {
    override document = GetDefaultCameraTemplateGraphDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaterialTagsDocument = gql`
    query getMaterialTags($materialId: ID!) {
  configuratorMaterial(materialId: $materialId) {
    id
    tagNames
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialTagsGQL extends Apollo.Query<GetMaterialTagsQuery, GetMaterialTagsQueryVariables> {
    override document = GetMaterialTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplateTagsDocument = gql`
    query getTemplateTags($templateId: ID!) {
  configuratorData(templateId: $templateId) {
    id
    tagNames
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateTagsGQL extends Apollo.Query<GetTemplateTagsQuery, GetTemplateTagsQueryVariables> {
    override document = GetTemplateTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }